const Page404 = () => {
  return (
    <div className="make-it-center">
      <h1>404 - NOT FOUND</h1>
    </div>
  );
};

export default Page404;
